import { render, staticRenderFns } from "./customVueTableCard.vue?vue&type=template&id=04619582&"
import script from "./customVueTableCard.vue?vue&type=script&lang=js&"
export * from "./customVueTableCard.vue?vue&type=script&lang=js&"
import style0 from "./customVueTableCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports